(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_0e68936"] && !Shopify.designMode) return;
  try {
    (function () {
    function initAiVerticalCardsAutoScroll(root) {
      var containers = (root || document).querySelectorAll(
        '[data-ai-vertical-cards-scroll][data-auto-scroll="true"]'
      );

      containers.forEach(function (container) {
        if (container.dataset.autoScrollInitialized === 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var track = container.firstElementChild;
        if (!track) return;

        var originalCards = Array.prototype.slice.call(track.children);
        if (originalCards.length === 0) return;

        var maxScroll = container.scrollWidth - container.clientWidth;
        if (maxScroll <= 1) return;

        container.dataset.autoScrollInitialized = 'true';

        originalCards.forEach(function (card) {
          var clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-auto-scroll-clone', 'true');
          clone.querySelectorAll('a').forEach(function (link) {
            link.setAttribute('tabindex', '-1');
          });
          track.appendChild(clone);
        });

        var firstClone = track.querySelector('[data-auto-scroll-clone="true"]');
        var loopWidth = firstClone ? firstClone.offsetLeft : track.scrollWidth / 2;
        var speed = parseFloat(container.dataset.scrollSpeed) || 1;
        var paused = false;
        var rafId = null;

        function tick() {
          if (!paused) {
            container.scrollLeft += speed;

            if (container.scrollLeft >= loopWidth) {
              container.scrollLeft -= loopWidth;
            }
          }
          rafId = requestAnimationFrame(tick);
        }

        function pause() {
          paused = true;
        }

        function resume() {
          paused = false;
        }

        container.addEventListener('mouseenter', pause);
        container.addEventListener('mouseleave', resume);
        container.addEventListener('touchstart', pause, { passive: true });
        container.addEventListener('touchend', resume, { passive: true });
        container.addEventListener('focusin', pause);
        container.addEventListener('focusout', resume);

        rafId = requestAnimationFrame(tick);

        container._aiVerticalCardsCleanup = function () {
          if (rafId) cancelAnimationFrame(rafId);
          container.removeEventListener('mouseenter', pause);
          container.removeEventListener('mouseleave', resume);
          container.removeEventListener('touchstart', pause);
          container.removeEventListener('touchend', resume);
          container.removeEventListener('focusin', pause);
          container.removeEventListener('focusout', resume);
          track.querySelectorAll('[data-auto-scroll-clone="true"]').forEach(function (clone) {
            clone.remove();
          });
          delete container.dataset.autoScrollInitialized;
        };
      });
    }

    function destroyAiVerticalCardsAutoScroll(root) {
      var containers = (root || document).querySelectorAll('[data-ai-vertical-cards-scroll]');
      containers.forEach(function (container) {
        if (typeof container._aiVerticalCardsCleanup === 'function') {
          container._aiVerticalCardsCleanup();
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAiVerticalCardsAutoScroll();
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAiVerticalCardsAutoScroll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAiVerticalCardsAutoScroll(event.target);
    });

    if (document.readyState !== 'loading') {
      initAiVerticalCardsAutoScroll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
